import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useNavModel from "../model/navModel";
import useGlobalModel from "../model/globalModel";
import { forFind } from "../utils/utils";
import menuData from "../data/menuData.json";
import { Layout } from "antd";
import VrmMenu from "./VrmMenu";
import VrmHeader from "./VrmHeader";
import VrmNav from "./VrmNav";
import VrmRoute from "./VrmRoute";
import { useDictModel } from "../views/base/dict/dictModel"
import { useCustomerModel } from "../views/base/customerFiles/customer/baseCustomerModel"
import { useSupplierModel } from "../views/base/supplier/supplierModel"
import { useStockStatisticModel } from "../views/stock/statistic/stockStatisticModel"
import { useWarehouseModel } from "../views/base/warehouse/warehouseModel"
import { useTechnicianModel } from "../views/base/technician/technicianModel"
import { useVehicleModel } from "../views/base/customerFiles/vehicle/vehicleModel"
import { useRoleModel } from "../views/system/roles/rolesModel"
import { useOrgModel } from "@/views/organization/org/orgModel";


const { Sider, Content } = Layout;

const Index = () => {

    const history = useHistory();
    const { user, cm, loadWarehouseAllData, appLoadDataAll, beLoadDataAll } = useGlobalModel();
    const { addNav } = useNavModel();
    const { loadData: loadDictData } = useDictModel()
    const { loadData: orgLoadData } = useOrgModel();
    const { loadCustomerAllData } = useCustomerModel()
    const { loadSupplierAllData } = useSupplierModel()
    // const { loadStockAllData } = useStockStatisticModel()
    // const { shelfLoadAllData } = useWarehouseModel()
    const { loadTechnician } = useTechnicianModel()
    const { loadVehicleAllData } = useVehicleModel()
    const { loadAllRolesData } = useRoleModel()

    // loadAllRolesData


    useEffect(() => {
        // 这里加载初始全局用到的数据
        loadDictData();
        orgLoadData();
        loadCustomerAllData();
        loadSupplierAllData();
        loadWarehouseAllData();
        // loadStockAllData();
        // shelfLoadAllData();
        loadTechnician();
        loadVehicleAllData();
        loadAllRolesData();
        appLoadDataAll();
        beLoadDataAll()
    }, [])
    //监听在地址栏输入url
    useEffect(() => {
        history.listen((location, action) => {
            console.log(action, location)
            if (action === "POP" && location.pathname !== "/login" && user.token) {
                // console.log(location)
                let findNav = forFind(menuData, location.pathname, "path", true);
                console.log(location, action, "监听路有变化", findNav)
                addNav(findNav ? findNav.id : "404");
            }
        });
        // eslint-disable-next-line
    }, []);

    return (
        <Layout style={{ height: "100vh" }}>
            <VrmHeader />
            <Layout>
                <Sider className="layout-sider" trigger={null} collapsible collapsed={cm.collapsed} width={226} collapsedWidth={80}>
                    <VrmMenu />
                </Sider>
                <Layout className="layout-section">
                    <VrmNav />
                    <Content>
                        <div className="layout-section-content">
                            <VrmRoute />
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    )
}

export default Index;